// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  Private: (t, data?, options?) => t('enum.visibility.private.name', data, options),
  Public: (t, data?, options?) => t('enum.visibility.public.name', data, options),
  Unlisted: (t, data?, options?) => t('enum.visibility.unlisted.name', data, options),
  /* eslint-enable max-len */
};
